import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export const StickyBar: React.FC = () => {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-red-600 text-white shadow-md" data-id="element-268">
      <div className="container mx-auto px-4 py-2 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4" data-id="element-269">
        <span className="font-bold text-sm sm:text-base uppercase tracking-wide" data-id="element-270">
          Esta oferta expira pronto
        </span>
        <CountdownTimer variant="light" data-id="element-271" />
      </div>
    </div>;
};